import { ChipProps } from '@mui/material/Chip';
import { MediumChipStyled, SmallChipStyled } from './j-chip.styled';

const Jchip = (props: ChipProps) => {
  switch (props.size) {
    case 'small':
      return <SmallChipStyled {...props} />;
    case 'medium':
      return <MediumChipStyled {...props} />;

    default:
      return <SmallChipStyled {...props} />;
  }
};
export default Jchip;
